import React from 'react';
import { useNavigate } from 'react-router-dom';
import Button from 'components/Button';
import NavigateBeforeIcon from '@mui/icons-material/NavigateBefore';
import { Container } from 'styles/pages/product-detail/navAction';

const Header = () => {
  const navigate = useNavigate();
  return (
    <Container>
      <Button
        containerStyle={{
          fontSize: '12px',
          border: '1px solid #F9682A',
          borderRadius: '16px',
          padding: '1px 22px',
          lineHeight: '22px',
          textTransform: 'inherit',
          color: '#ffffff',
          background: '#F9682A',
          fontFamily: 'Inter600',
        }}
        // startIcon={<NavigateBeforeIcon />}
        variant='text'
        title='Back'
        onClick={() => navigate(-1)}
      />
    </Container>
  );
};

export default Header;
